import { useNoticeDetail } from '@/pages/customer-support/notice/hook/useNoticeDetail';

const NoticeDetailPage = () => {
	const { noticeDetailClickGoList } = useNoticeDetail();

	return (
		<main id="sub" className="sub notice">
			<section id="" className="sub-content hidden">
				<div className="sub-inner">
					<div className="board-wrap">
						{/* <!-- 임시 --> */}
						<div className="board-detail">
							<div className="detail-head">
								<strong className="title">{/*<!-- title -->*/}</strong>
								<span className="date">{/*<!-- date -->*/}</span>
							</div>

							<div className="detail-body">
								<div className="text-box">{/*<!-- content -->*/}</div>
							</div>

							<div className="detail-foot">
								<ul>
									<li>
										<a className="detail-next-btn">
											<i className="ico-board-up" aria-hidden="true"></i>
											다음글
											{/*<!-- [Dev] 가장 최신 목록인 경우 first class 추가 -->*/}
											<p className="title">{/*<!-- title -->*/}</p>
											{/*<!-- <p class="title first">새로운 기능이 추가되었습니다!</p> -->*/}
										</a>
									</li>
									<li>
										<a className="detail-prev-btn">
											<i className="ico-board-down" aria-hidden="true"></i>
											이전글
											{/*<!-- [Dev] 가장 마지막 목록인 경우 last class 추가 -->*/}
											<p className="title">
												{/*<!-- title -->
												 */}
											</p>
										</a>
									</li>
								</ul>
							</div>
							<div className="button-group">
								<button className="btn primary" onClick={noticeDetailClickGoList}>
									목록
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
};

export default NoticeDetailPage;
